import React, { Component, type ReactNode } from 'react';
import { styled } from '@compiled/react';
import { components } from '@atlaskit/select';
import { token } from '@atlaskit/tokens';
import type { ItemGroup } from '../../../../model/index.tsx';

type Props = {
	isLoading: boolean;
	listHeading: string;
	options: ItemGroup[];
	children: ReactNode | null;
};

// eslint-disable-next-line jira/react/no-class-components
export default class MenuListContent extends Component<Props> {
	renderListHeading() {
		const { listHeading, options, isLoading } = this.props;
		if (!listHeading || isLoading || !options || options.length === 0) {
			return null;
		}

		return <ListHeadingWrapper>{listHeading}</ListHeadingWrapper>;
	}

	render() {
		const { listHeading, children, ...props } = this.props;
		return (
			// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; isLoading: boolean; options: ItemGroup[]; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': clearValue, cx, getStyles, getValue, and 7 more.
			<components.MenuList {...props}>
				{this.renderListHeading()}
				{children}
			</components.MenuList>
		);
	}
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ListHeadingWrapper = styled.div({
	fontWeight: token('font.weight.medium'),
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	paddingTop: token('space.150'),
	paddingRight: token('space.150'),
	paddingBottom: token('space.100'),
	paddingLeft: token('space.150'),
});
